import { FilterTypes } from 'Core/interfaces'

import { UrlParams } from 'Portals/Customer/constants'
import { Kpi, KpiMetricFilterFields } from 'Portals/Customer/entities'
import i18n from 'Portals/Customer/utils/i18nService'

export const getFiltersConfig = (): Kpi.Metric.Filter.EditConfig => ({
	[KpiMetricFilterFields.kpiCategoryMetric]: {
		label: `${i18n.t('pages:location.filters.label.kpiCategoryId')}:`,
		apiFilterFieldName: KpiMetricFilterFields.kpiCategoryMetric,
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.kpiCategoryMetric,
		defaultValue: null,
		placeholder: i18n.t('pages:location.filters.placeholder.kpiCategoryId')
	},
	[KpiMetricFilterFields.kpiId]: {
		label: `${i18n.t('pages:location.filters.label.kpiId')}:`,
		apiFilterFieldName: KpiMetricFilterFields.kpiId,
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.kpiId,
		defaultValue: null,
		placeholder: i18n.t('pages:location.filters.placeholder.kpi')
	},
	[KpiMetricFilterFields.year]: {
		label: `${i18n.t('pages:location.filters.label.year')}:`,
		apiFilterFieldName: KpiMetricFilterFields.year,
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.year,
		defaultValue: null,
		placeholder: i18n.t('pages:location.filters.placeholder.year')
	}
})
